export function mapWalletCredit(data) {
  return {
    amount: data.credit,
    currency: data.currency,
  }
}
